import selectSkypeNotificationOption from '../data/mutators/selectSkypeNotificationOption';
import SkypeNotificationType from '../data/store/schema/SkypeNotificationType';
import SkypeOptionViewState from '../data/store/schema/SkypeOptionViewState';
import getSkypeOptions from '../data/store/store';
import getUserSkypeOptions from '../utils/getUserSkypeOptions';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { getFallbackValueIfNull } from 'owa-options-core';
import { SkypeNotificationOptions } from 'owa-outlook-service-options';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';

export interface SkypeNotificationFullProps {
    optionStore?: SkypeOptionViewState;
    userOptions?: SkypeNotificationOptions;
}

interface SkypeNotificationChoice {
    key: string;
    text: string;
}

@reactive({
    optionStore: () => getSkypeOptions(),
    userOptions: () => getUserSkypeOptions(),
})
export default class SkypeNotificationFull extends React.Component<SkypeNotificationFullProps, {}> {
    render(): JSX.Element {
        let { optionStore, userOptions } = this.props;

        let imNotificationType = getFallbackValueIfNull(
            optionStore.imNotification as number,
            userOptions.skypeMessageNotification
        ).toString();

        let callNotificationType = getFallbackValueIfNull(
            optionStore.callNotification as number,
            userOptions.skypeCallingNotification
        ).toString();

        let choices: SkypeNotificationChoice[] = [
            {
                key: SkypeNotificationType.ToastAndSound.toString(),
                text: strings.options_skype_NotifyAll,
            },
            {
                key: SkypeNotificationType.ToastOnly.toString(),
                text: strings.options_skype_NotifyToast,
            },
            {
                key: SkypeNotificationType.None.toString(),
                text: strings.options_skype_ImNotifyNone,
            },
        ];

        return (
            <div>
                <ChoiceGroup
                    label={strings.options_skype_ImNotifityTitle}
                    selectedKey={imNotificationType}
                    options={choices}
                    onChange={(ev?: any, option?: IChoiceGroupOption) =>
                        this.onChange(option, true /* isImNotification*/)
                    }
                />
                <ChoiceGroup
                    label={strings.options_skype_CallNotifityTitle}
                    selectedKey={callNotificationType}
                    options={choices}
                    onChange={(ev?: any, option?: IChoiceGroupOption) =>
                        this.onChange(option, false /* isImNotification*/)
                    }
                />
            </div>
        );
    }

    private onChange = (option: IChoiceGroupOption, isImNotification: boolean) => {
        selectSkypeNotificationOption(this.getNotificationType(option.key), isImNotification);
    };

    private getNotificationType(num: string): SkypeNotificationType {
        switch (num) {
            case '1':
                return SkypeNotificationType.ToastAndSound;
            case '2':
                return SkypeNotificationType.ToastOnly;
            default:
                return SkypeNotificationType.None;
        }
    }
}
